import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TclcFeesProcessComponent } from '../tclc-fees-process/tclc-fees-process.component';
@Component({
  selector: 'app-tclc-fees',
  templateUrl: './tclc-fees.component.html',
  styleUrls: ['./tclc-fees.component.scss']
})
export class TclcFeesComponent implements OnInit {
  FeeForm: FormGroup;
  FeeTempletList: any;
  FeeModeList: any;
  FeeTempList: any;
  payBtnShow;
  PayBtn = true;
  PayStatus = false;
  StudentIdd: string;
  FeePaid: string;
  StuData: any;
  constId = 0;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Caste: '';
  ShowMsg = false;
  FeeTable: [];
  feeApplyArray: FormArray;
  dialogRef: MatDialogRef<any>;
  ADMRecords: any[];
  Dates: any[];
  Message: string;
  ApprovalCheck = false;
  Message2: string;
  TempMsg = false;
  Message3 = '';
  FullName: string;
  TclcId: any;
  TclcData: any;
  StuId: any;
  Certificate: string;
  TclcSavedData: any;
  PayableHeadsCount: number = 0;
  SelectedSubjectIds: number[] = [];
  SelectedHeadIds: number[] = [];
  SelectedSubjectCount: number = 0;
  SelectedHeadCount: number = 0;

  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  sessionNo = sessionStorage.getItem('session');
  collegeName
  courseName
  Tclcdata = [];
  ngOnInit(): void {
    this.TclcId = 0
    this.TclcSavedData = this.umsService.getTclcData();
    this.PayableHeadsCount = (this.TclcSavedData && this.TclcSavedData[0] && this.TclcSavedData[0].PayableHeadsCount) || 0;
    this.SelectedSubjectIds = (this.TclcSavedData && this.TclcSavedData[0] && this.TclcSavedData[0].SelectedSubjectIds) || [];
    this.SelectedHeadIds = (this.TclcSavedData && this.TclcSavedData[0] && this.TclcSavedData[0].SelectedHeadIds) || [];
    this.SelectedSubjectCount = (this.TclcSavedData && this.TclcSavedData[0] && this.TclcSavedData[0].SelectedSubjectCount) || 0;
    this.SelectedHeadCount = (this.TclcSavedData && this.TclcSavedData[0] && this.TclcSavedData[0].SelectedHeadCount) || 0;
    // alert(
    //   'TclcFees ngOnInit()\n\n' +
    //   'PayableHeadsCount: ' + this.PayableHeadsCount + '\n' +
    //   'SelectedSubjectIds: ' + JSON.stringify(this.SelectedSubjectIds) + '\n' +
    //   'SelectedHeadIds: ' + JSON.stringify(this.SelectedHeadIds) + '\n' +
    //   'SelectedSubjectCount: ' + this.SelectedSubjectCount + '\n' +
    //   'SelectedHeadCount: ' + this.SelectedHeadCount + '\n\n' +
    //   'Raw TclcSavedData[0]:\n' + JSON.stringify(this.TclcSavedData && this.TclcSavedData[0])
    // );

    this.prepopulation()
    this.PayBtn = true;
    this.ShowMsg = false;
    this.Message = '';
    this.ApprovalCheck = false;
    this.Message2 = '';
    this.TempMsg = false;
    this.Message3 = '';
    this.PayStatus = false;
    // this.ValidateFees()
    this.getRgId(this.TclcData);
    // this.getFeeTempData();
    this.getFeeModeData();


  }

  GetTclcdata(Data) {
    const payload: any = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CoCode'] = Data[0]['StuCourse'];
    payload['CgCode'] = Data[0]['StuCollege'];
    payload['CertType'] = Data[0]['CertType']
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status) {
        // if(payload.CertType == 'ASC'){
        //   this.Tclcdata = res.data.filter(data => data.StuId == this.StuId && data.CertType == 'ASC' && data.StuExam)
        // }
        // subid is not passed for other cert types
        this.Tclcdata = res.data.filter(data => data.StuId == this.StuId)
        this.getTclc()
        switch (this.Tclcdata[0]['CertType']) {
          case "TC":
            this.Certificate = 'Transfer Certificate'
            break
          case "LC":
            this.Certificate = 'Leaving Certificate'
            break;
          case "MC":
            this.Certificate = 'Migration Certificate'
            break;
          case "TS":
            this.Certificate = 'Transcript Certificate'
            break;
          case "ASC":
            this.Certificate = ' Photocopy of answerbook'
            break;
          case "RET":
            this.Certificate = 'Retotaling of marks'
            break;
          case "LANG":
            this.Certificate = 'Language Certificate'
              break;
          case "ATTFE":
            this.Certificate = 'Attestation Fee'
              break;
          case "VOD":
            this.Certificate = 'Verification of University Document'
              break;
          default:

            break
        }
        // this.Tclcdata = res.data[0]
      }
    })
  }

  ValidateFees() {
    const payload = {}
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId") != null ? sessionStorage.getItem("StudentPersonalId") : sessionStorage.getItem('StudentRGID');
    payload['FeeType'] = this.TclcSavedData[0]['CertType'];
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getRgId(this.TclcSavedData);
      // this.getFeeTempData();
      this.getFeeModeData();
    })
  }

  getFeeModeData() {
    // this.spinner.show();
    const payload = {};
    payload["Session"] = parseInt(this.sessionNo);
    payload['College'] = sessionStorage.getItem("StuCgId") != null ? sessionStorage.getItem("StuCgId") : this.TclcSavedData[0].StuClg,
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        // this.spinner.hide();
        if (res.status) {
          this.FeeModeList = res.data;
          sessionStorage.setItem('FeeMode', res.data[0].FeeMode);

          if (res.data[0].FeeMode == 'ONLIN') {
            this.payBtnShow = true;
          } else {
            this.payBtnShow = false;
          }
        }
        else {

          this.payBtnShow = true;
        }

      });
  }

  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;

    }, (ERROR: HttpErrorResponse) => {
      // this.collegedataList = [];
      this.spinner.hide();
    })
  }


  getCourse(CoCode) {
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchCourseType(payload).subscribe(res => {
      this.spinner.hide();
      this.courseName = res.data[0].CoName;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getFeeTempData(TclcData) {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = this.TclcSavedData[0]['CertType'];
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.TempMsg = false;
        this.Message3 = '';
        // this.Table = true;
        this.FeeTable = res.data;
        this.StudentIdd = sessionStorage.getItem("StudentPersonalId") != null ? sessionStorage.getItem("StudentPersonalId") : sessionStorage.getItem('StudentRGID');
        this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd)

      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          // this.Table = false;
          this.FeeTable = [];
          this.TempMsg = true;
          this.Message3 = 'Template Not Defined For This Criteria';
          this.ShowMsg = false;
          this.Message = ''
        }

      }
    });
  }

  prepopulation() {
    // this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.FullName = res.data[0]['StuFirstNameEng'] + " " + res.data[0]['StuMidNameEng'] + " " + res.data[0]['StuLastNameEng']
        if ((res.data[0]['StuFirstName'] == undefined || res.data[0]['StuFirstName'] == null)
          || (res.data[0]['StuMidName'] == undefined || res.data[0]['StuMidName'] == null)
          || (res.data[0]['StuLastName'] == undefined || res.data[0]['StuLastName'] == null)) {
          this.FullName = res.data[0].StuFullNameEng;
        } else {
          this.FullName = res.data[0]['StuFirstNameEng'] + " " + res.data[0]['StuMidNameEng'] + " " + res.data[0]['StuLastNameEng']

        }

        this.StuId = res.data[0].StuId
        this.GetTclcdata(this.TclcSavedData)
        this.prepopulationOfAddmission(res.data[0].StuId)

      }
      else {
        this.StuId = sessionStorage.getItem('StudentRGID')
        this.FullName = this.TclcSavedData[0].StudentName
        this.getcollege(this.TclcSavedData[0].StuClg)
        this.getCourse(this.TclcSavedData[0].StuCourse)
        this.GetTclcdata(this.TclcSavedData)
        this.prepopulationOfAddmission(res.data[0].StuId)
      }
    })
  }

  prepopulationOfAddmission(StuId) {
    // this.spinner.show();
    let payload = {};
    payload['StuId'] = StuId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.getcollege(res.data[0].StuCgId)
        this.getCourse(res.data[0].StuCoId)
      }
      else {
        this.getcollege(this.TclcSavedData[0].StuClg)
        this.getCourse(this.TclcSavedData[0].StuCourse)
      }
    })
  }

  SearchFeeDetails(TempCode, StdId) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.sessionNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {


      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });
        if (data === res.data[0]['TotalPaidAmount']) {
          this.PayBtn = false;

          if (this.TclcSavedData.CertType === 'ASC') {

            const alreadyAttached = this.TclcSavedData.AllSubjectData.some(item =>
              item.StuSubId == this.TclcSavedData.StuSubId &&
              item.PaymentResponseID && item.PaymentResponseID != '' &&
              item.CertType === 'ASC'
            );
            if (alreadyAttached) {
              this.PayStatus = true;
              this.FeePaid = 'Fees Paid';
              return;
            }
          }
          if (this.TclcSavedData.CertType === 'RET') {

            const alreadyAttached = this.TclcSavedData.AllSubjectData.some(item =>
              item.StuSubId == this.TclcSavedData.StuSubId &&
              item.PaymentResponseID && item.PaymentResponseID != '' &&
              item.CertType === 'RET'
            );
            if (alreadyAttached) {
              this.PayStatus = true;
              this.FeePaid = 'Fees Paid';
              return;
            }
          }
          if (this.TclcSavedData.CertType === 'LANG') {

            const alreadyAttached = this.TclcSavedData.AllSubjectData.some(item =>
              item.StuSubId == this.TclcSavedData.StuSubId &&
              item.PaymentResponseID && item.PaymentResponseID != '' &&
              item.CertType === 'LANG'
            );
            
            if (alreadyAttached) {
              this.PayStatus = true;
              this.FeePaid = 'Fees Paid';
              return;
            }
          }

          this.PayStatus = true;
          this.FeePaid = 'Fees Paid';
        }

        else if (data != res.data[0]['TotalPaidAmount']) {
          this.PayBtn = true;
          this.PayStatus = false;
        }



      } else {
        this.PayBtn = true;
        this.PayStatus = false;
      }
    });

  }

  openFeeProcessPopUp(item) {
    // localStorage.clear();
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['TclcId'] = this.Tclcdata[0]['TclcId']
    data['CertType'] = this.Tclcdata[0]['CertType']
    data['DestClg'] = this.Tclcdata[0]['DestClg']
    data['Reason'] = this.Tclcdata[0]['Reason']
    data['SnNo'] = this.Tclcdata[0]['SnNo']
    data['StuBranch'] = this.Tclcdata[0]['StuBranch']
    data['StuCollege'] = this.Tclcdata[0]['StuCollege']
    data['StuCourse'] = this.Tclcdata[0]['StuCourse']
    data['StuExam'] = this.Tclcdata[0]['StuExam']
    data['StuFaculty'] = this.Tclcdata[0]['StuFaculty']
    data['StuId'] = this.Tclcdata[0]['StuId']
    data['StuSubId'] = this.TclcSavedData[0]['StuSubId']
    data['PayableHeadsCount'] = this.PayableHeadsCount
    data['AllSubjectData'] = this.TclcSavedData[0].AllSubjectData

    data['SelectedSubjectIds'] = this.SelectedSubjectIds
    data['SelectedHeadIds'] = this.SelectedHeadIds
    data['SelectedSubjectCount'] = this.SelectedSubjectCount
    data['SelectedHeadCount'] = this.SelectedHeadCount

    // alert(
    //   'openFeeProcessPopUp() — Forwarding to TclcFeesProcess\n\n' +
    //   'CertType: ' + data['CertType'] + '\n' +
    //   'TemplateCode: ' + item.TemplateCode + '\n\n' +
    //   'PayableHeadsCount: ' + data['PayableHeadsCount'] + '\n' +
    //   'SelectedSubjectIds: ' + JSON.stringify(data['SelectedSubjectIds']) + '\n' +
    //   'SelectedHeadIds: ' + JSON.stringify(data['SelectedHeadIds']) + '\n' +
    //   'SelectedSubjectCount: ' + data['SelectedSubjectCount'] + '\n' +
    //   'SelectedHeadCount: ' + data['SelectedHeadCount']
    // );

    const dialogRef4 = this.dialog.open(TclcFeesProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: "auto",
        data
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }


  addnewrecord(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['SnNo'] = this.sessionNo
    data['TemplateCode'] = item.TemplateCode
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '80vh',
      // height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getRgId(TclcData) {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'], TclcData)
        this.getFeeTempData(TclcData);
      }
      else {
        this.getFeeTempData(TclcData);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.getFeeTempData(TclcData);
    })
  }

  examform(RgId, TclcData) {
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload)
      .subscribe((res) => {
        if (res.status) {
          this.getFeeTempData(TclcData);

        } else {
          this.getFeeTempData(TclcData);
        }

      }, (ERROR: HttpErrorResponse) => {
        this.getFeeTempData(TclcData);
      });

  }

  getTclc() {
    const payload = {};
    payload['CertType'] = this.TclcSavedData[0]['CertType'];
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    this.umsService.GetTclc(payload).subscribe((res) => {
      if (res.status) {
        this.TclcId = res.data[0]['TclcId']
      }
    })
  }

}